import { render } from "./footer-view.vue?vue&type=template&id=34e54fb3&scoped=true"
import script from "./footer-view.vue?vue&type=script&lang=js"
export * from "./footer-view.vue?vue&type=script&lang=js"

import "./footer-view.vue?vue&type=style&index=0&id=34e54fb3&lang=scss&scoped=true"

import exportComponent from "D:\\dev_program\\web\\haorun-changliuxiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e54fb3"]])

export default __exports__